import styled from 'styled-components';

export const H1 = styled.h1`
  font-size: 3.5rem;
  color: ${({ theme }) => theme.colors.paragraph};
`;

export const H2 = styled.h2`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.paragraph};
`;

export const H3 = styled.h3`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.paragraph};
`;
